import { FC } from 'react';
import {
  Row, Col, Typography, Spin, Button,
} from 'taxaroo-ui';
import moment from 'moment';
import Copy from 'src/assets/icons/copy.svg';
import AiOpen from 'src/assets/icons/ai-open.svg';
import { AiAgentMessageEntity, TaxarooAiMessageType } from '~src/graphql';
import * as styles from './styles.module.css';

const { Text, Link } = Typography;

type AiMessageListProps = {
  messages: Array<AiAgentMessageEntity>;
  aiAgentMessagesLoading: boolean;
  hasMore: boolean;
  loadMore: () => Promise<void>;
};

const SpecialMessages = {
  terms: (
    <div key="terms">
      <Row justify="space-between" className={styles.msg}>
        <Row className={[styles.msgText, styles.msgSpecial]}>
          <Text>
            Welcome to Taxaroo AI!
            {'\n\n'}
            You can chat here or talk to Taxaroo AI with your microphone
            to get your questions answered and complete your tasks.
            {'\n\n'}
            By using Taxaroo AI, you are agreeing to the following&nbsp;
            <Link href="https://taxaroo.com/terms-of-use" target="_blank" rel="noreferrer">Terms</Link>
            .
          </Text>
        </Row>
      </Row>
    </div>
  ),
};

const AiMessageList:FC<AiMessageListProps> = ({
  messages, aiAgentMessagesLoading, hasMore, loadMore,
}) => {
  if (aiAgentMessagesLoading) {
    return (
      <Row justify="center" align="middle">
        <Spin />
      </Row>
    );
  }

  return (
    <>
      {hasMore && (
        <Row justify="center" align="middle" style={{ paddingBottom: '20px' }}>
          <Button type="default" onClick={() => loadMore()}>
            Load More Messages
          </Button>
        </Row>
      )}
      {messages
        .map((msg, index) => {
          if (msg.type === TaxarooAiMessageType.Assistant) {
            return (
              <div key={index}>
                <Row justify="space-between" className={styles.msg}>
                  <Row className={[styles.msgText, styles.msgAssistant]}>{msg.text}</Row>
                  <Row className={styles.msgCopy} align="middle">
                    <Copy
                      className={styles.msgCopyIcon}
                      onClick={() => navigator.clipboard.writeText(msg.text)}
                    />
                  </Row>
                </Row>
                <Row justify="start" className={styles.msgTime}>{moment(msg.createAt).format('LT')}</Row>
              </div>
            );
          }

          if (msg.type === TaxarooAiMessageType.User) {
            return (
              <div key={index}>
                <Row justify="end" className={styles.msg}>
                  <Row className={[styles.msgText, styles.msgUser]}>{msg.text}</Row>
                </Row>
                <Row justify="end" className={styles.msgTime}>{moment(msg.createAt).format('LT')}</Row>
              </div>
            );
          }

          if (msg.type === TaxarooAiMessageType.System) {
            return (
              <div key={index}>
                <Row justify="center" align="bottom" style={{ padding: '10px 0' }}>
                  <Col>
                    <AiOpen className={styles.expirationCardIcon} />
                  </Col>
                  <Col style={{ paddingLeft: '10px' }}>
                    <Text strong className={styles.blueText}>
                      {msg.text}
                    </Text>
                  </Col>
                </Row>
              </div>
            );
          }

          if (msg.type === TaxarooAiMessageType.Special) {
            return SpecialMessages[msg.more];
          }

          return null;
        })
        .filter((val) => val)}
    </>
  );
};

export default AiMessageList;
